import { DecimalPipe, getCurrencySymbol } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ 
    name: 'currency', 
    standalone: true,
})
export class CurrencyConvertPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe){}

    transform(value: any, currencyCode: string, addDecimals: boolean = true, useUtf: boolean = false, toUpper: boolean = false, ...args: any[]) {
        // value = Math.round(value * 100) / 100;
        // value = Math.trunc(value);
        if(value == undefined)
            value = 0;
        
        if (typeof value !== "number") {
            const parsed = Number(value); 
            if (!isNaN(parsed)) {
                value = parsed;
            } 
        }
        
        if(addDecimals) {
            if(toUpper)
                value = Math.ceil(value);
            else
                value = value.toFixed(2)
        } else {
            value = Math.round(value);
        }
        
        value = this.decimalPipe.transform(value, '1.2-2', 'en-US')
        
        return this.formatSymbol(value, currencyCode, useUtf);
    }

    transformWithoutRounding(value: any, currencyCode: string, addDecimals: boolean = true, useUtf: boolean = false) {
        if(value == undefined)
            value = 0;
        
        value = this.decimalPipe.transform(value, '1.2-2', 'en-US')
        
        return this.formatSymbol(value, currencyCode, useUtf);
    }

    private formatSymbol(value: any, currencyCode: string, useUtf: boolean){
        if(currencyCode == "PLN")
            return `${value} ${useUtf ? 'zł' : 'PLN'}`;    
        
        let currencySymbol = getCurrencySymbol(currencyCode, 'narrow');
        
        if(['CAD', 'MXN'].includes(currencyCode)){
            return `${currencyCode.substring(0,2)}${currencySymbol}${value}`;
        }

        if(['USD', 'GBP'].includes(currencyCode))
            return `${currencySymbol}${value}`;

        return `${value} ${currencySymbol}`;
    }
}